import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './tailwind.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { RecoilRoot, useRecoilValue } from 'recoil';
import axios from 'axios';
import { ChakraProvider } from "@chakra-ui/react";
import { Worker } from '@react-pdf-viewer/core';
import { testApi, cancelApi } from "./utils/apiManager";


// axios.defaults.baseURL = process.env.REACT_APP_DEV_API_BASE_URL;
// axios.defaults.baseURL = 'https://swiftapprove-backend-9402cfc7ddaa.herokuapp.com/'
axios.defaults.baseURL = process.env.REACT_APP_DEV_API_BASE_URL || process.env.REACT_APP_DEV_API_BASE_URL || 'https://swiftapprove-backend-9402cfc7ddaa.herokuapp.com/';

if (typeof window !== "undefined") {
  window.testApi = testApi;
  window.cancelApi = cancelApi;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">

  <RecoilRoot>
    <ChakraProvider>
      <App />
    </ChakraProvider>
  </RecoilRoot>
  </Worker>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
